import { ISSUE_NAVIGATOR_ACTION_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { Source } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { fireUiEvent } from '@atlassian/jira-forge-ui-analytics/src/common/utils/consumers/index.tsx';
import {
	getEventId,
	getEventIdOld,
} from '@atlassian/jira-forge-ui-analytics/src/common/utils/index.tsx';
import { forgeModulesConcurrentLoadTime } from '@atlassian/jira-forge-ui-analytics/src/common/utils/performance-analytics/main.tsx';
import {
	MODULE_TYPE_TRIGGER,
	UI_ACTIONS,
} from '@atlassian/jira-forge-ui-analytics/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const triggerEventId = getEventIdOld({
	module: ISSUE_NAVIGATOR_ACTION_MODULE,
	moduleType: MODULE_TYPE_TRIGGER,
});

export const fireUiTriggerClickedEvent = (
	extensionId: string,
	source?: Source,
	attributes?: Attributes,
) => {
	forgeModulesConcurrentLoadTime(extensionId).start({ startTime: performance.now() });

	return fireUiEvent(UI_ACTIONS.CLICKED, {
		id: fg('ditto-fcf-support-new-manifest-on-frontend')
			? getEventId({
					module: ISSUE_NAVIGATOR_ACTION_MODULE,
					moduleType: MODULE_TYPE_TRIGGER,
				})
			: triggerEventId,
		source,
		attributes,
	});
};
